import { Cell } from '@table-library/react-table-library/table';
import moment from 'moment';
import Action from './modal/EditProject';
import Prompts from './components/prompts';
import Platforms from './components/platforms';
import Competitors from './components/competitors';
import DomainImage from '../../../components/DomainImage';

export const COLUMNS = (t, updateData, onOpenModal) => [
    {
        label: t('ai_tracking.projects.columns.name'),
        key: 'name',
        data: 'name',
        Component: Cell,
        cellSize: 'minmax(180px, 1.5fr)',
        sortType: 'string',
        renderCell: ({ data, item, csvDownload }) => {
            if (csvDownload) return data;
            return (
                <div className="ai-tracking-project-name">
                    <div className="ai-tracking-project-name-top">
                        <a
                            href={`/ai-tracking/project/${item.id}/`}
                            className="ai-tracking-prompt-link"
                        >
                            {data}
                            <span style={{ fontSize: '20px', marginLeft: '3px' }}>
                                {' '}
                                <i className="icon-arrow-right1 fs-14" />
                            </span>
                        </a>
                        {item.is_disabled && (
                            <span className="ai-tracking-disabled-tag">
                                {t('ai_tracking.projects.labels.disabled')}
                            </span>
                        )}
                        {item.is_default && (
                            <span className="ai-tracking-default-selected">
                                {t('ai_tracking.projects.labels.defaultSelected')}
                            </span>
                        )}
                    </div>
                    <div className="ai-tracking-project-name-bottom">
                        <Platforms prompts={item.prompts} />
                    </div>
                </div>
            );
        },
    },
    {
        label: t('ai_tracking.projects.columns.brand_domain'),
        key: 'own_product_name',
        data: 'own_product_name',
        Component: Cell,
        sortType: 'string',
        renderCell: ({ item, csvDownload }) => {
            if (csvDownload) return item?.own_domain;
            return (
                <div className="ai-tracking-country-language">
                    <div className="ai-tracking-country-language-country">
                        {item.own_product_name || '-'}
                    </div>
                    <div className="ai-tracking-country-language-lan">
                        {item.own_domain ? (
                            <div>
                                <DomainImage domain_name={item.own_domain} size="18" />{' '}
                                {item.own_domain}
                            </div>
                        ) : (
                            '-'
                        )}
                    </div>
                </div>
            );
        },
    },
    {
        label: t('ai_tracking.projects.columns.keywords'),
        key: 'prompts',
        data: 'prompts',
        Component: Cell,
        className: 'w-100',
        cellSize: 'minmax(180px, 1.8fr)',
        style: () => {
            return { width: '100%' };
        },
        renderCell: ({ data, item, csvDownload }) => {
            if (csvDownload) return item?.prompts?.map((x) => x.prompt).join(', ');
            const shownData = data?.length ? (
                <Prompts project={item} data={data} />
            ) : (
                t('ai_tracking.projects.labels.noData')
            );

            return (
                <div className="d-flex gap-8 justify-content-between w-100">
                    <div className="w-100">{shownData}</div>
                </div>
            );
        },
    },
    {
        label: t('ai_tracking.projects.columns.competitors'),
        key: 'competitors',
        data: 'competitors',
        cellSize: 'minmax(180px, 1.8fr)',
        Component: Cell,
        sortType: 'string',
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data?.map((x) => x.domain).join(', ');
            const shownData = data?.length ? (
                <Competitors data={data} />
            ) : (
                t('ai_tracking.projects.labels.noData')
            );

            return (
                <div className="d-flex gap-8 justify-content-between w-100">
                    <div className="w-100">{shownData}</div>
                </div>
            );
        },
    },
    {
        label: t('ai_tracking.projects.columns.createdAt'),
        key: 'created_at',
        data: 'created_at',
        sortType: 'string',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            const date = moment(data).format('YYYY-MM-DD');
            const time = moment(data).format('HH:mm');
            return (
                <div className="ai-tracking-country-language">
                    <div className="ai-tracking-country-language-country">{date}</div>
                    <div className="ai-tracking-country-language-lan">({time})</div>
                </div>
            );
        },
    },
    {
        label: t('ai_tracking.projects.columns.actions'),
        key: 'actions',
        data: 'actions',
        cellSize: 'minmax(310px, 2fr)',
        Component: Cell,
        sortType: 'string',

        renderCell: ({ item, csvDownload }) => {
            if (csvDownload) return null;
            return (
                <Action
                    item={item}
                    updateData={updateData}
                    is_default={item.is_default}
                    is_disabled={item.is_disabled}
                />
            );
        },
    },
];
